/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntroductionInquiryLogDto } from '../../models/introduction-inquiry-log-dto';

export interface IntroductionInquiryLogControllerFindAll$Params {
}

export function introductionInquiryLogControllerFindAll(http: HttpClient, rootUrl: string, params?: IntroductionInquiryLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntroductionInquiryLogDto>>> {
  const rb = new RequestBuilder(rootUrl, introductionInquiryLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IntroductionInquiryLogDto>>;
    })
  );
}

introductionInquiryLogControllerFindAll.PATH = '/api/introduction-inquiry-log';
